import React from "react";
// import { render } from "react-snapshot";
import ReactDOM from 'react-dom';
import App from "./App";

ReactDOM.render(<App />, document.getElementById('root'));
// render(<App />, document.getElementById("root"));
